import { createShoppingCartsClient } from './client';

export const updateDeliveryServiceAsync = async (deliveryServiceId: string) => {
  const shoppingCartsClient = createShoppingCartsClient();
  if (deliveryServiceId) {
    await shoppingCartsClient.addDeliveryService(deliveryServiceId);
  } else {
    await shoppingCartsClient.removeDeliveryService();
  }
};
